import {
  useEffectWithController,
  usePromise
} from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import SavedSearchesContext from '~/contexts/SavedSearchesContext';
import { useUser } from '~/contexts/UserContext';
import { readSavedSearch } from '~/services/savedSearch';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetSavedSearches() {
  const mounted = usePromise();
  const {
    savedSearches: { setData, isLoaded, isLoading, setLoaded, setLoading }
  } = useContext(SavedSearchesContext);

  const {
    data: { email, isLoggedIn },
    isLoaded: isUserLoaded,
    isLoading: isUserLoading
  } = useUser();

  useEffectWithController(
    controller => {
      if (isUserLoading && !isLoading) {
        setLoading();

        return;
      }

      if (!email && isUserLoaded && !isLoaded) {
        setLoaded();

        return;
      }

      if (!email || !isUserLoaded || !isLoggedIn || isLoaded) return;

      mounted(readSavedSearch(email, controller))
        .then(({ data }) => {
          setData(data.savedSearches ?? [], {
            shouldSetLoaded: true
          });
        })
        .catch(generateErrorLogger('SavedSearches'));
    },
    [
      email,
      isUserLoaded,
      isUserLoading,
      isLoggedIn,
      mounted,
      isLoading,
      isLoaded,
      setLoading,
      setLoaded,
      setData
    ]
  );
}
